const API_BASE = '/api/v1/public/projects';

// ── Types ──────────────────────────────────────────────────────────────────────

export type PopulationMethod = 'building_refined' | 'census_network_length';

export interface PopulationStatus {
  runId: string;
  projectId: string;
  status: string;
  method: PopulationMethod;
  sourceCensusYear: number;
  totalPopulationInput: number;
  totalPopulationAssigned: number;
  totalPopulationUnassigned: number;
  totalHouseholdsInput: number;
  totalHouseholdsAssigned: number;
  edgeCount: number;
  radioCount: number;
  unassignedRadioCount: number;
  assignmentPct: number;
  createdAt: string;
  completedAt: string | null;
  errorMessage: string | null;
}

export interface PopulationFeatureProperties {
  edge_id: string;
  population_estimated: number | null;
  households_estimated: number | null;
  nbi_households_estimated: number | null;
  source_radios_count: number | null;
  source_buildings_count: number | null;
  network_length_m: number | null;
  length_meters: number | null;
  road_class: string | null;
  method: string;
}

export interface PopulationGeoJsonMeta {
  runId: string;
  projectId: string;
  method: string;
  totalPopulationInput: number;
  totalPopulationAssigned: number;
  assignmentPct: number;
  edgeCount: number;
  featureCount: number;
}

export interface PopulationGeoJson {
  type: 'FeatureCollection';
  features: Array<{
    type: 'Feature';
    geometry: { type: 'LineString'; coordinates: number[][] };
    properties: PopulationFeatureProperties;
  }>;
  meta: PopulationGeoJsonMeta;
}

// ── Fetch ──────────────────────────────────────────────────────────────────────

export async function getPublicPopulationStatus(
  slug: string,
  method?: PopulationMethod,
): Promise<PopulationStatus> {
  const params = method ? `?method=${method}` : '';
  const res = await fetch(`${API_BASE}/${slug}/population-segments/status${params}`);
  if (!res.ok) throw new Error(`Population status: error ${res.status}`);
  return res.json() as Promise<PopulationStatus>;
}

export async function getPublicPopulationGeoJson(
  slug: string,
  method?: PopulationMethod,
): Promise<PopulationGeoJson> {
  const params = method ? `?method=${method}` : '';
  const res = await fetch(`${API_BASE}/${slug}/population-segments/geojson${params}`);
  if (!res.ok) throw new Error(`Population GeoJSON: error ${res.status}`);
  return res.json() as Promise<PopulationGeoJson>;
}
